'use strict';

module.exports = {
  routingNumber: require('./src/routing-number'),
  accountNumber: require('./src/account-number')
};



//////////////////
// WEBPACK FOOTER
// ./~/us-bank-account-validator/index.js
// module id = 702
// module chunks = 0